import connectionBO from "../../services/connectionBO";

export const ordersStore = {
    namespaced: true,
    state: {
        listOrders: {},
        detailOrders: {},
        basketItem: {},
        basketItemComponent: {}
    },
    mutations: {
        LIST_ORDERS: (state, listOrders) => {
            state.listOrders = listOrders;
        },
        DETAILS_ORDERS: (state, detailOrders) => {
            state.detailOrders = detailOrders;
        },
        SET_BASKET_ITEM(state, basketItem) {
            state.basketItem = basketItem;
        },
        SET_BASKET_ITEM_COMPONENT(state, component) {
            state.basketItemComponent = component;
        }
    },
    getters: {
        getOrdersDetail: state => state.detailOrders,
        getOrdersList: state => state.listOrders,
        getBasketItem: state => state.basketItem,
        getBasketItemComponent: state => state.basketItemComponent
    },
    actions: {
        detailOrders(context, value) {
            return connectionBO.getOrdersDetail(value).then(response => {
                context.commit("DETAILS_ORDERS", response.code !== 400 ? response : { code: 400 });
            });
        },
        listOrders(context) {
            return connectionBO.getOrdersList().then(response => {
                context.commit("LIST_ORDERS", response.code !== 400 ? response : { code: 400 });
            });
        },
        setBasketItem(context, basketItem) {
            context.commit("SET_BASKET_ITEM", basketItem);
        },
        setBasketItemComponent(context, component) {
            context.commit("SET_BASKET_ITEM_COMPONENT", component);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/orders/OrdersStore.js